import React from 'react';
import { getPriceDisplay } from '../../../../../../modules/catalog/services/catalog';
export default function ItemVariation(_ref) {
  var name = _ref.name,
    price = _ref.price,
    precision = _ref.precision,
    isOnlyVariation = _ref.isOnlyVariation,
    isLastVariation = _ref.isLastVariation,
    displayZeroCostItemPrices = _ref.displayZeroCostItemPrices;
  var variationStyle = {
    margin: 0
  };
  var finalPrice = getPriceDisplay(price, {
    displayZeroCost: displayZeroCostItemPrices,
    precision: precision
  });
  return /*#__PURE__*/React.createElement("p", {
    className: "item-variation",
    style: variationStyle
  }, finalPrice, " ", !isOnlyVariation && name, !isLastVariation ? /*#__PURE__*/React.createElement("span", {
    style: {
      margin: '0 0.25rem'
    }
  }, "/") : '');
}
ItemVariation.defaultProps = {
  price: 0,
  precision: 2,
  isOnlyVariation: false,
  isLastVariation: false,
  displayZeroCostItemPrices: false
};